/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SddMandate } from './SddMandate';
import {
    SddMandateFromJSON,
    SddMandateFromJSONTyped,
    SddMandateToJSON,
} from './SddMandate';

/**
 * 
 * @export
 * @interface RegisterSddMandateOutput
 */
export interface RegisterSddMandateOutput {
    /**
     * 
     * @type {SddMandate}
     * @memberof RegisterSddMandateOutput
     */
    sSDMandate?: SddMandate;
    /**
     * 
     * @type {Error}
     * @memberof RegisterSddMandateOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the RegisterSddMandateOutput interface.
 */
export function instanceOfRegisterSddMandateOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RegisterSddMandateOutputFromJSON(json: any): RegisterSddMandateOutput {
    return RegisterSddMandateOutputFromJSONTyped(json, false);
}

export function RegisterSddMandateOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterSddMandateOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sSDMandate': !exists(json, 'SSDMandate') ? undefined : SddMandateFromJSON(json['SSDMandate']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function RegisterSddMandateOutputToJSON(value?: RegisterSddMandateOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'SSDMandate': SddMandateToJSON(value.sSDMandate),
        'error': value.error,
    };
}

